/**
 * Pose une feuille `<style id>` dans le document, une fois par id : un composant monté dix fois ne la
 * duplique pas. Sans document (le natif), ne fait rien.
 */
export function injectStyleOnce(id: string, css: string) {
    if (typeof document === "undefined" || document.getElementById(id) != null) return
    const style = document.createElement("style")
    style.id = id
    style.textContent = css
    document.head.appendChild(style)
}
